"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserToJSON = exports.UserFromJSONTyped = exports.UserFromJSON = exports.instanceOfUser = exports.attributeTypeMapUser = void 0;
exports.attributeTypeMapUser = [
    {
        name: "id",
        type: "string",
    },
    {
        name: "name",
        type: "string",
    },
    {
        name: "email",
        type: "string",
    },
    {
        name: "isPaidAccount",
        type: "boolean",
    },
    {
        name: "planType",
        type: "string",
    },
    {
        name: "accountDateFormat",
        type: "string",
    },
    {
        name: "apiIdsEnabled",
        type: "boolean",
    },
    {
        name: "isConfirmedAccount",
        type: "boolean",
    },
    {
        name: "dbxUserId",
        type: "string",
    },
];
/**
 * Check if a given object implements the User interface.
 */
function instanceOfUser(value) {
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("name" in value) || value["name"] === undefined)
        return false;
    if (!("email" in value) || value["email"] === undefined)
        return false;
    if (!("isPaidAccount" in value) || value["isPaidAccount"] === undefined)
        return false;
    if (!("planType" in value) || value["planType"] === undefined)
        return false;
    if (!("accountDateFormat" in value) ||
        value["accountDateFormat"] === undefined)
        return false;
    if (!("apiIdsEnabled" in value) || value["apiIdsEnabled"] === undefined)
        return false;
    if (!("isConfirmedAccount" in value) ||
        value["isConfirmedAccount"] === undefined)
        return false;
    if (!("dbxUserId" in value) || value["dbxUserId"] === undefined)
        return false;
    return true;
}
exports.instanceOfUser = instanceOfUser;
function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
exports.UserFromJSON = UserFromJSON;
function UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json["id"],
        name: json["name"],
        email: json["email"],
        isPaidAccount: json["is_paid_account"],
        planType: json["plan_type"],
        accountDateFormat: json["account_date_format"],
        apiIdsEnabled: json["api_ids_enabled"],
        isConfirmedAccount: json["is_confirmed_account"],
        dbxUserId: json["dbx_user_id"],
    };
}
exports.UserFromJSONTyped = UserFromJSONTyped;
function UserToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        name: value["name"],
        email: value["email"],
        is_paid_account: value["isPaidAccount"],
        plan_type: value["planType"],
        account_date_format: value["accountDateFormat"],
        api_ids_enabled: value["apiIdsEnabled"],
        is_confirmed_account: value["isConfirmedAccount"],
        dbx_user_id: value["dbxUserId"],
    };
}
exports.UserToJSON = UserToJSON;
